<template>
  <div class="page-con">
    <div class="page-con-header clearfix sel-modal-header">
      <el-select v-model="searchFormData.companyName" filterable multiple placeholder="请选择所属公司" collapse-tags style="margin-right: 10px;">
        <el-option
            v-for="item in companyNameList"
            :key="item.paramValue"
            :label="item.paramValue"
            :value="item.paramValue">
        </el-option>
      </el-select>
      <el-select v-model="searchFormData.clientName" multiple clearable filterable collapse-tags
                 placeholder="请选择客户" style="margin-right: 10px;">
        <el-option v-for="(item,index) in clientNameList" :key="index" :value="item.paramValue" :label="item.paramValue"></el-option>

      </el-select>
      <el-select v-model="searchFormData.salesMan" multiple clearable filterable collapse-tags
                 placeholder="请选择业务员" style="margin-right: 10px;">
        <el-option v-for="(item,index) in salesManList" :key="index" :value="item.paramValue" :label="item.paramValue"></el-option>

      </el-select>
      <el-select v-model="searchFormData.clientManager" multiple clearable filterable collapse-tags
                 placeholder="请选择客户经理" style="margin-right: 10px;width: 190px;">
        <el-option v-for="(item,index) in clientManagerList" :key="index" :value="item.paramValue" :label="item.paramValue"></el-option>

      </el-select>
      <el-select v-model="searchFormData.salesManager" multiple clearable filterable collapse-tags
                 placeholder="请选择销售经理" style="margin-right: 10px;width: 190px;">
        <el-option v-for="(item,index) in salesManagerList" :key="index" :value="item.paramValue" :label="item.paramValue"></el-option>

      </el-select>

      <el-select v-model="searchFormData.year"  filterable collapse-tags style="width: 87px;"
                 placeholder="请选择年份">
        <el-option v-for="(item,index) in yearList" :key="index" :value="item.paramValue" :label="item.paramValue"></el-option>

      </el-select>
      <div class="search-box">
        <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">刷新</vxe-button>
        <Button status="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 5px">
          搜索
        </Button>
        <Button status="primary" @click="exportInvoiceCount" style="margin-left: 10px;border-radius: 5px">
          导出
        </Button>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          show-overflow
          stripe
          style="width: 100%;"
          align="center"
          border="none"
          :loading="loading"
          :footer-method="footerMethod1"
          :data="tableData"
      >

        <vxe-table-column field="companyName" title="所属公司"></vxe-table-column>
        <vxe-table-column field="clientName" title="客户"></vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员"></vxe-table-column>
        <vxe-table-column field="clientManager" title="客户经理"></vxe-table-column>
        <vxe-table-column field="salesManager" title="销售经理"></vxe-table-column>
        <vxe-table-column field="m1" title="1月份"></vxe-table-column>
        <vxe-table-column field="m2" title="2月份"></vxe-table-column>
        <vxe-table-column field="m3" title="3月份"></vxe-table-column>
        <vxe-table-column field="m4" title="4月份"></vxe-table-column>
        <vxe-table-column field="m5" title="5月份"></vxe-table-column>
        <vxe-table-column field="m6" title="6月份"></vxe-table-column>
        <vxe-table-column field="m7" title="7月份"></vxe-table-column>
        <vxe-table-column field="m8" title="8月份"></vxe-table-column>
        <vxe-table-column field="m9" title="9月份"></vxe-table-column>
        <vxe-table-column field="m10" title="10月份"></vxe-table-column>
        <vxe-table-column field="m11" title="11月份"></vxe-table-column>
        <vxe-table-column field="m12" title="12月份"></vxe-table-column>
        <vxe-table-column field="totalAmount" title="合计"></vxe-table-column>

      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
  import $api from '@/apiProvider';
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {getBlob, hideLoading, saveBlob, showLoading} from "@/utils/util";
  import moment from "moment";

  export default {
    mixins: [getAuthOrization],
    data() {
      return {
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100
        },
        loading:false,
        searchFormData:{
          year:new Date().getFullYear()
        },
        tableData: [],
        countTotal:{
          totalM1:null,
          totalM2:null,
          totalM3:null,
          totalM4:null,
          totalM5:null,
          totalM6:null,
          totalM7:null,
          totalM8:null,
          totalM9:null,
          totalM10:null,
          totalM11:null,
          totalM12:null,
          totalAmount:null,
        },
        companyNameList:[],
        clientManagerList:[],
        clientNameList:[],
        salesManList:[],
        salesManagerList:[],
        yearList:[],
      }
    },
    filters: {

    },
    mounted() {
      this.$bus.$on("销项分类统计", () => {
        this.searchFormData = {
          year:new Date().getFullYear()
        };
        this.invoiceCount();
      });
      this.invoiceCountCompanyName();
      this.invoiceCountClientName();
      this.invoiceCountSalesMan();
      this.invoiceCountSalesManager();
      this.invoiceCountYear();
      this.invoiceCountClientManager();
      this.invoiceCount();
    },
    methods: {
      async invoiceCount() {
        this.loading = true;
        let res = await $api.report.request('invoiceCount', {
          clientManager: this.searchFormData.clientManager,
          clientName: this.searchFormData.clientName,
          companyName:  this.searchFormData.companyName,
          salesMan:  this.searchFormData.salesMan,
          page: this.page.currentPage,
          rows: this.page.pageSize,
          salesManager: this.searchFormData.salesManager,
          type: 2,
          year: this.searchFormData.year,

        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          let data = res.data.rows;
          this.tableData = data;
          this.countTotal = res.data.countRtnVo;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async exportInvoiceCount() {
        // let res = await $api.report.get('exportInvoiceCount', {
        //   clientManager: this.searchFormData.clientManager,
        //   clientName: this.searchFormData.clientName,
        //   companyName:  this.searchFormData.companyName,
        //   salesMan:  this.searchFormData.salesMan,
        //   page: this.page.currentPage,
        //   rows: this.page.rows,
        //   salesManager: this.searchFormData.salesManager,
        //   type: 2,
        //   year: this.searchFormData.year,
        //
        // });
        let res = getBlob(
            "/api/order/report/exportInvoiceCount",
            {
              clientManager: this.searchFormData.clientManager,
              clientName: this.searchFormData.clientName,
              companyName:  this.searchFormData.companyName,
              salesMan:  this.searchFormData.salesMan,
              page: 1,
              rows: this.page.rows,
              salesManager: this.searchFormData.salesManager,
              type: 2,
              year: this.searchFormData.year,
            }
        );
        hideLoading();
        await saveBlob("导出销项统计.xls", res.data);
      },
      async invoiceCountCompanyName() {
        this.loading = true;
        let res = await $api.report.request('invoiceCountCompanyName', {
          type: 2,
        });
        if (res.status === 1) {
          this.companyNameList = res.data;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async invoiceCountClientName() {
        this.loading = true;
        let res = await $api.report.request('invoiceCountClientName', {
          type: 2,
        });
        if (res.status === 1) {
          this.clientNameList = res.data;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async invoiceCountSalesMan() {
        this.loading = true;
        let res = await $api.report.request('invoiceCountSalesMan', {
          type: 2,
        });
        if (res.status === 1) {
          this.salesManList = res.data;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async invoiceCountSalesManager() {
        this.loading = true;
        let res = await $api.report.request('invoiceCountSalesManager', {
          type: 2,
        });
        if (res.status === 1) {
          this.salesManagerList = res.data;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async invoiceCountYear() {
        this.loading = true;
        let res = await $api.report.request('invoiceCountYear', {
          type: 2,
        });
        if (res.status === 1) {
          this.yearList = res.data;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async invoiceCountClientManager() {
        this.loading = true;
        let res = await $api.report.request('invoiceCountClientManager', {
          type: 2,
        });
        if (res.status === 1) {
          this.clientManagerList = res.data;
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      search() {
        this.page.currentPage = 1
        this.invoiceCount();
      },
      refresh(){
        this.invoiceCount();
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.invoiceCount();
      },
      footerMethod1({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 2) {
              return "单页合计";
            }
            if (this.tableData == null || this.tableData.length == 0){
              return null
            }
            if (["m1","m2","m3","m4","m5","m6","m7","m8","m9","m10","m11","m12","totalAmount"].includes(column.property)) {
                return this.$utils.sum(data, column.property)
            }
            return null;
          }),
          columns.map((column, columnIndex) => {
            if (columnIndex === 2) {
              return "全部合计";
            }
            if (["m1"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM1;
              }
             else return null
            }
            if (["m2"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM2;
              }
              else return null
            }
            if (["m3"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM3;
              }
              else return null
            }
            if (["m4"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM4;
              }
            }
            if (["m5"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM5;
              }
            }
            if (["m6"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM6;
              }
            }
            if (["m7"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM7;
              }
            } if (["m8"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM8;
              }
            } if (["m9"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM9;
              }
            } if (["m10"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM10;
              }
            } if (["m11"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM11;
              }
            }
            if (["m12"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalM12;
              }
            }
            if (["totalAmount"].includes(column.property)) {
              if (this.countTotal != null){
                return this.countTotal.totalAmount;
              }
            }
            return null;
          }),
        ];
      }
    }
  }
</script>

<style>
  @import "../../../src/assets/icon/icon-navigate/iconfont.css";

  .modal-container {
    position: relative;
    height: 100%
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .navigate, .navigate:active, .navigate:focus, .navigate:hover {
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;
  }
  .el-select__tags-text {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-select .el-tag__close.el-icon-close {
    top: -7.5px;
  }

</style>
